import * as React from "react";

import DeprecatedButton from "@v1/components/designSystem/button/Button";
import Popover from "@v1/components/designSystem/popover/Popover";
import BundleDiscountsCustomPropModifier from "@v1/components/editor/customProp/BundleDiscountsCustomPropModifier";
import BundleProductsCustomPropModifier from "@v1/components/editor/customProp/BundleProductsCustomPropModifier";
import { selectDraftComponent } from "@v1/reducers/core-reducer";
import { useEditorSelector } from "@v1/store/store";

export const BundleBuilderConfigMenu: React.FC = () => {
  const draftComponent = useEditorSelector(selectDraftComponent);
  if (!draftComponent) {
    return null;
  }
  return (
    <div className="relative flex flex-col gap-4">
      <BundleProductsCustomPropModifier component={draftComponent} />
      <Popover.Root shouldIgnoreOutsideInteractions={false}>
        <Popover.Trigger asChild>
          <DeprecatedButton variant="secondary">
            Configure Discounts
          </DeprecatedButton>
        </Popover.Trigger>
        <Popover.Content
          stayInPosition
          shouldPreventDefaultOnInteractOutside={false}
          side="left"
          align="center"
          hideCloseButton
          className="w-[300px]"
        >
          <BundleDiscountsCustomPropModifier component={draftComponent} />
        </Popover.Content>
      </Popover.Root>
    </div>
  );
};
